<section class="legal-shell">
  <div class="legal-card">
    <p class="eyebrow">Page publique</p>
    <h1>Politique de confidentialite</h1>
    <p class="lead">
      AfriFood collecte et traite un volume limite de donnees personnelles pour fournir l'acces au
      compte, les fonctionnalites recettes, communautaires et support dans l'application et
      l'interface d'administration.
    </p>

    <div class="section">
      <h2>Donnees susceptibles d'etre collectees</h2>
      <ul>
        <li>Donnees de compte comme l'adresse email, le nom affiche et le mot de passe chiffre.</li>
        <li>Donnees de profil que vous choisissez de fournir dans l'application ou au support.</li>
        <li>Donnees techniques et d'usage necessaires a la securite et a l'amelioration du service.</li>
        <li>Contenus publies, notamment recettes, commentaires, avis, signalements et medias.</li>
      </ul>
    </div>

    <div class="section">
      <h2>Pourquoi nous utilisons ces donnees</h2>
      <ul>
        <li>Authentifier votre compte et securiser le service.</li>
        <li>Afficher votre profil, vos recettes et vos interactions communautaires.</li>
        <li>Traiter la moderation, la prevention des abus, le support et les obligations legales.</li>
        <li>Faire fonctionner les notifications, les diagnostics et les ameliorations du service.</li>
      </ul>
    </div>

    <div class="section">
      <h2>Demande de suppression des donnees</h2>
      <p>
        Si vous souhaitez supprimer votre compte et les donnees personnelles associees, envoyez un
        email a
        <a href="mailto:support.afrifood@afrimoov.com">support.afrifood@afrimoov.com</a>.
      </p>
      <p>Pour accelerer le traitement, merci d'indiquer :</p>
      <ul>
        <li>l'adresse email utilisee pour le compte,</li>
        <li>votre nom complet ou nom affiche,</li>
        <li>tout identifiant utile lie au compte,</li>
        <li>une demande explicite de suppression de vos donnees.</li>
      </ul>
      <p>
        Une verification complementaire peut etre demandee avant suppression. Certaines donnees
        peuvent etre conservees lorsque cela est necessaire pour la securite, la prevention de la
        fraude ou le respect d'obligations legales.
      </p>
    </div>

    <div class="section">
      <h2>Contact</h2>
      <p>
        Pour toute question sur la confidentialite ou le support, contactez
        <a href="mailto:support.afrifood@afrimoov.com">support.afrifood@afrimoov.com</a>.
      </p>
    </div>

    <div class="actions">
      <a routerLink="/data-deletion-request">Voir la procedure de suppression</a>
      <a routerLink="/login">Retour a la connexion admin</a>
    </div>
  </div>
</section>
